"use client";

import { rouvrirChoixCookies } from "@/lib/analytics";

/** Rouvre le bandeau de consentement (politique de confidentialité). */
export function BoutonGererCookies({ className }: { className?: string }) {
  return (
    <button type="button" onClick={rouvrirChoixCookies} className={className}>
      Gérer les cookies
    </button>
  );
}
